export const texts = [
    [
        {
          text: 'I lit that up. Burnt orange crisp',
          count: 400,
          fontSize: 100,
        },
        {
          text: 'Hot steel and melting iron',
          count: 800,
          fontSize: 100,
        },
        {
          text: "Now there's a sour tower to where grey clouds gather.",
          count: 1200,
          fontSize: 50,
        },
        {
          text: 'Haha!!',
          count: 1600,
          fontSize: 250,
        },
        {
          text: "Didn't I tell you?",
          count: 2000,
          fontSize: 100,
        },
        {
          text: 'It was a firesale!',
          count: 2400,
          fontSize: 200,
        },
        {
          text: '',
          count: 3000,
          fontSize: 400,
        },
      ],
    [
        {
          text: 'After things cleared \n I saw the moon',
          count: 400,
          fontSize: 100,
        },
        {
          text: 'It left a wild path \n of silver light',
          count: 800,
          fontSize: 100,
        },
        {
          text: "Twisted turns tumbling through shadows",
          count: 1200,
          fontSize: 100,
        },
        {
          text: 'I see the moonlight trail in the dark sky',
          count: 1600,
          fontSize: 100,
        },
        {
          text: "Time was running down, \n winding away",
          count: 2000,
          fontSize: 100,
        },
        {
          text: 'So let me tell everything \n What I took I should not have \n But it is done \n and I am here \n unknown',
          count: 2400,
          fontSize: 100,
        },
        {
          text: '',
          count: 3000,
          fontSize: 400,
        },
      ],
      [
        {
          text: 'Red crisp and crackle',
          count: 400,
          fontSize: 200,
        },
        {
          text: 'That burning wood and ash smell',
          count: 800,
          fontSize: 125,
        },
        {
          text: 'Caustic heat and sweet black smoke',
          count: 1200,
          fontSize: 100,
        },
        {
          text: 'Please put it out',
          count: 1600,
          fontSize: 200,
        },
        {
          text: 'Before I catch a cold',
          count: 2000,
          fontSize: 100,
        },
        {
          text: '',
          count: 3000,
          fontSize: 10,
        },
      ],
];

export default texts;